
<template ref='bm'>
  <div>
      <div class="container">
    <h1><font-awesome-icon icon="home" /> Home -  <a href="#">Process Payment </a></h1>

<div class="row">
<div class="col-md-12">
<div class="panal mt-20">
<div class="panal-header">Payment list </div>
<div class="panal-body " >
    <div class="table table-responsive col-md-10   m-auto" >
        <table  id="ChargesTable" border="1"  class="tabel" width="100%">
            <thead>
                <tr class="text-uppercase jumbotron" style="text-transform:capitalize">
                    
                    <th align="center" class="text-center"><strong>Payment Name</strong></th>
                    <th align="center" class="text-center"><strong>Value</strong></th>
                </tr>
            </thead>

            <tbody class="text-center" id="ChargesTableData">
                <tr v-for="(data,index) in products" v-bind:key="index">
                   
                    <td>{{data.Description}}
                    </td>
                   
                    <td>{{data.Price}}
                    </td>
                   
                    </tr>
                   
            </tbody>
            <tfoot>
                <tr class="text-center">
                    <td class="bg-gray">Total Amount</td>
                    <td>{{Lst.TotalAmount}}</td>
                </tr>
            </tfoot>
        </table>
       </div>
        <p class="mt-50 alert alert-warning">  Please Review your payment List Carefully then Press Confirm Button </p>

<div class="text-center"> 
<b-link class="btn btn-primary mr-20" @click="$router.push('wallet')">

                       <i class="fa fa-backword"></i>back
                      </b-link>
         <input type="button" value="confirm" onclick="Checkout.showLightbox();" class="btn btn-success" />
         
</div>    <!-- <input type="image" class="mt-50" @click="GetMerchantRefNumber" src="https://www.atfawry.com/ECommercePlugin/resources/images/atfawry-ar-logo.png" alt="Edfa3 Fawry" id="xsrrs" /> -->
    </div>
    
        <b-modal id="confirm" title="Payment Completed" :header-bg-variant="headerBgVariant" ok-only @ok="GoWallet">
    <p class="my-4 text-center"> <b-icon icon="bell-fill" class="  p-2 text-success"></b-icon></p>
    <p class="text-center">

      

      Payment Completed <br/>

            Thank You!
    </p>
    
    
  </b-modal>
    
  </div>
</div>
</div>
      </div>
  </div>
  
</template>
<!--<script src="https://banquemisr.gateway.mastercard.com/checkout/version/58/checkout.js"
            data-error="errorCallback"
            data-cancel="cancelCallback"
            data-beforeRedirect="beforeRedirect"
            data-afterRedirect="afterRedirect"
            data-complete="completeCallback">
    </script>-->
<script>

import { API_URL } from '../../services/API_URL'
// eslint-disable-next-line
console.log(API_URL)
 window.completeCallbackResult = ''
function errorCallback(error){
    // eslint-disable-next-line
 console.log("error result",error)
}
function beforeRedirect(error){
    // eslint-disable-next-line
 console.log(error)
}
function afterRedirect(error){
    // eslint-disable-next-line
 console.log(error)
}
function cancelCallback(error){
    // eslint-disable-next-line
 console.log("cancel resulr",error)
}
function completeCallback (result){
    window.completeCallbackResult = result
   window.completeFunction(result)
console.log("suceess resulr",result)
}

import ApplicantDataServices from '../../services/Applicant/ApplicantData.services'

export default {
    

   data(){
       return{
        headerBgVariant:'primary',
    ChargesTableData:[],
    products : [],
    Lst : [],
    successIndicator : '',
    sessionversion : '',
    result : '',
    Order : '',
    complete : window.completeCallbackResult
    
       }
   },
   beforeMount() {
       
              if(this.PaymentStore.length == 0 ) this.$router.push('/wallet')

                 let  scripts = [
      "https://banquemisr.gateway.mastercard.com/checkout/version/58/checkout.js",
      
    ];
     scripts.forEach(script => {
      let tag = document.createElement("script");
      tag.setAttribute('type', "text/javascript") ;
      tag.setAttribute("src", script);
      tag.defer =true;
      tag.setAttribute ("data-error" , 'errorCallback');
      tag.setAttribute ("data-cancel" , 'cancelCallback');
      tag.setAttribute ("data-beforeRedirect" , 'beforeRedirect');
      tag.setAttribute ("data-afterRedirect" , 'afterRedirect');
      tag.setAttribute ("data-complete" , 'completeCallback');
      document.head.appendChild(tag);
    });


  },
   mounted(){
      window.errorCallback = errorCallback
window.beforeRedirect = beforeRedirect
window.afterRedirect = afterRedirect
window.cancelCallback = cancelCallback
window.completeCallback = completeCallback
   
       window['completeFunction'] = (result)=>{
           this.completeCallback(result)
       }
       this.PaymentStore.forEach(element => {
         var product = {};
        product.PaymentID  = element.PaymentID;
        product.Description = element.Description;
        product.Price       = element.Price;
        
        this.products.push(product);
        ApplicantDataServices.ApplicantMPGSRepeatedPaymnet(element.PaymentID).then( response => 
        {
            if(response.data == 1) this.$router.push('/wallet')
        })
    });
    ApplicantDataServices.ApplicantBankMasr_MPGS(this.currentUser.UserIDSerial ,this.products).then(Result =>{
        // eslint-disable-next-line
        debugger

        console.log(Result.data)
        if (Result.data) {
                        
                        this.Lst = Result.data;
                        this.successIndicator = this.Lst.successIndicator;
                        this.sessionversion = this.Lst.sessionversion;
                        this.result = this.Lst.result;
                        this.Order = this.Lst.OrderId;

                        //Checkout Configure
                        /*eslint-disable-next-line*///
                        if(window.Checkout){
                        window.Checkout.configure({
                            merchant: this.Lst.merchant,
                            order: {
                                currency: this.Lst.currency,
                                description: 'Order No ' + this.Lst.OrderId
                            },
                            session: {
                                id: this.Lst.sessionid
                            },
                            interaction: {
                                merchant: {
                                    name: 'Sinai University'
                                },
                                locale: 'en_US',

                                displayControl: {
                                    orderSummary: 'SHOW',
                                    paymentConfirmation: 'SHOW',
                                    billingAddress: 'HIDE',
                                    customerEmail: 'HIDE',
                                    shipping: 'HIDE',
                                    paymentTerms: 'SHOW_IF_SUPPORTED'
                                }
                            }
                            
                        });
                        /*eslint-disable-next-line*///
                         console.log('config' , Checkout.configure)
                          }
                         
                       
                    }else{
                        this.$router.push('/wallet')
                    }
    }).catch( // this.$router.push('/wallet')
    )
   },
   methods:
   {
       test(){
           alert('test')
       },

        // This method preserves the current state of successIndicator and orChargeListerId, so they're not overwritten when we return to this page after redirect
         beforeRedirect() {
           
            return {
                successIndicator: this.successIndicator,
                orderId: this.Order
            };
        },

        // This method is specifically for the full payment page option. Because we leave this page and return to it, we need to preserve the
        // state of successIndicator and orderId using the beforeRedirect/afterRedirect option
         afterRedirect(data) {
           /*eslint-disable-next-line*/
            console.log(data)
            //Redirect to Wallet page
            this.$router.push('/wallet')
        },

         errorCallback(error) {
                /*eslint-disable-next-line*/
                console.log(error)
            //Redirect to Wallet page
            this.$router.push('/wallet')
        },

        //Cancel
         cancelCallback() {
            
            //Redirect to Wallet page
            this.$router.push('/wallet')
        },

        // This handles the response from Hosted Checkout and redirects to the appropriate endpoint
         completeCallback(response) {
           // alert(response)
            // Save the resultIndicator
             let resultIndicator = response;
               this.$bvModal.show("confirm")
            if (resultIndicator === this.successIndicator) {

                ApplicantDataServices.ApplicantBankMasr_MPGS_retriveOreder(this.currentUser.UserIDSerial,this.Order,resultIndicator , this.sessionversion).then(Result => {
                     if (Result.length > 0) {
                            this.Lst = Result;
                           this.result = this.Lst[0].Result;
                      
                            //Redirect to Receipt page
                           // window.location.href = "/BankMasrReceipt_MPGS?SUOrderID=" + Order + "&Result=" + result;
                        }
                        else {
                            //Redirect to Wallet page
                          //   this.$router.push('/wallet')
                        }
                })//.catch( this.$router.push('/wallet'))
                
            }
            // else {
            //     //Redirect to Wallet page
            //      this.$router.push('/wallet')
            // }
        },
GoWallet(){
this.$router.push('/wallet')
}

   },
   computed:{
       PaymentStore(){
              return this.$store.state.auth.paymentList 
        },
     currentUser() {
        return this.$store.state.auth.user
      },
      reviewApplication(){
       return  this.$store.state.auth.renderReview 
       },
       CompResult(){
           if(window.completeCallbackResult == "" || window.completeCallbackResult == undefined){
                return this.complete
           }else{
             return  this.completeCallback(window.completeCallbackResult)
           }
         
       }


   },
   watch:{
       CompResult(){
           return this.CompResult()
       }
   }

}
</script>

<style>
h1{
    color:#285475;
    font-size:25px;
    border-bottom:1px #646464 dashed;
    padding:10px 0px;
}
h1 a{
    color:#50BD77;
}
table tr th {
    background-color: #4caf5000 !important;
    color:#333;
    font-weight:bold;
}

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}
.app-stu-photo{
    float:right;
    width:200px;
    border-radius:10px;
    border:1px solid #111;
    margin-top:20px;
}
.app-stu-photo img{
    width:100%;
      border-radius:10px;
      
}
.app-All{
    width:80%;
    float:left;
}
.app-stu{
    border-bottom:1px #333 dotted;
    padding:10px 0px;

}
.app-stu .title{
    font-weight:bold;

}

.app-stu .title span{
    font-weight: 100;


    
}

.table .thead-light th {

    font-size: 14px !important;
}
.mt-50{
    margin-top: 50px !important;
}
.m-auto{
    margin: auto !important;
}
bg-gray{
    background-color: #eee;
}
.mr-20{
    margin-right: 20px;
}
</style>